import { isEmptyObject } from "../../../lib/utils";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

export const formValidator = (values, t) => {
  let formErrors = {};
  let ImportFrom = values["ImportFrom"];
  let SelectedDataset = values["SelectedDataset"];
  let File = values["File"];
  let SelectedSheet = values["SelectedSheet"];
  let DatabaseType = values["DatabaseType"];
  let Database = values["Database"];
  let Server = values["Server"];
  let Username = values["Username"];
  let Password = values["Password"];
  let ChooseFrom = values["ChooseFrom"];
  let Table = values["Table"];
  let Query = values["Query"];
  let Url = values["Url"];
  let Method = values["Method"];

  if (!ImportFrom) {
    formErrors = Object.assign(formErrors, {
      Title: t("datasets.importdataset.option"),
    });
  }
  if (!SelectedDataset) {
    formErrors = Object.assign(formErrors, {
      SelectedDataset: t("datasets.importdataset.dataset1"),
    });
  }
  if (!File) {
    formErrors = Object.assign(formErrors, {
      File: t("datasets.importdataset.file2"),
    });
  }
  if (!SelectedSheet) {
    formErrors = Object.assign(formErrors, {
      SelectedSheet: t("datasets.importdataset.sheet2"),
    });
  }
  if (!DatabaseType) {
    formErrors = Object.assign(formErrors, {
      DatabaseType: t("datasets.importdataset.datatype2"),
    });
  }
  if (!Database) {
    formErrors = Object.assign(formErrors, {
      Database: t("datasets.importdataset.database2"),
    });
  }
  if (!Server) {
    formErrors = Object.assign(formErrors, {
      Server: t("datasets.importdataset.server2"),
    });
  }
  if (!Username) {
    formErrors = Object.assign(formErrors, {
      Username: t("datasets.importdataset.username2"),
    });
  }
  if (!Password) {
    formErrors = Object.assign(formErrors, {
      Password: t("datasets.importdataset.password2"),
    });
  }

  if (ChooseFrom == "table" && !Table) {
    formErrors = Object.assign(formErrors, {
      Table: t("datasets.importdataset.table2"),
    });
  }

  if (ChooseFrom == "query" && !Query) {
    formErrors = Object.assign(formErrors, {
      Query: t("datasets.importdataset.table2"),
    });
  }
  
  if (!Url) {
    formErrors = Object.assign(formErrors, {
      Url: t("datasets.importdataset.url2"),
    });
  }

  if (!Method) {
    formErrors = Object.assign(formErrors, {
      Method: t("datasets.importdataset.method2"),
    });
  }
  //console.log(formErrors)
  if (isEmptyObject(formErrors)) return undefined;
  //console.log("formErrors", formErrors);
  return formErrors;
};
